import React from "react";

/* Simplified multicolor SBP-style mark (8-slice pinwheel) */
export const SbpMark = ({ size = 26 }) => {
  const C = 16;
  const R = 14;
  const pts = [];
  for (let i = 0; i < 8; i++) {
    const a = (Math.PI / 4) * i - Math.PI / 2;
    pts.push([C + R * Math.cos(a), C + R * Math.sin(a)]);
  }
  const colors = [
    "#1E5BFF", "#00B7FF", "#00C389", "#A6E22E",
    "#FFD166", "#FF8A3D", "#FF4D4D", "#6A5CFF",
  ];
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" aria-hidden="true">
      {pts.map((p, i) => {
        const n = pts[(i + 1) % 8];
        return (
          <polygon
            key={i}
            points={`${C},${C} ${p[0].toFixed(2)},${p[1].toFixed(2)} ${n[0].toFixed(2)},${n[1].toFixed(2)}`}
            fill={colors[i]}
          />
        );
      })}
      <circle cx={C} cy={C} r="4.5" fill="white" />
    </svg>
  );
};
